import React from "react";

export default function IndexPage() {
  return <div>test</div>;
}
